import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { AUTOMATION_RULES_API } from '../api/automation-rules-api';
import { AutomationRuleViewInterface, RuleId } from '../types/automation-rule-interface';
export const useSaveRule = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.put,
      showFieldsErrorToast: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    t1 = {
      fetcher: async (id, data) => {
        ;
        try {
          return await fetcher(`${AUTOMATION_RULES_API}/${id}`, data, {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/x-www-form-urlencoded"
            }
          });
        } catch (t2) {
          const e = t2;
          throw e;
        }
      }
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};